import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";
import { SanitizeHTMLString } from "@circle-react-shared/uikit/SanitizeContent";
import { Loader } from "@circle-react-uikit/Loader";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";

import { t } from "@/i18n-js/instance";

import { useSpacesLimitAddonState } from "./useSpacesLimitAddonState";

export const SpacesLimitAddonModalUIKitComponent = () => {
  const modal = useModal();
  const {
    addon,
    isLoading,
    isSubmitting,
    handleConfirm,
    buildDescription,
    i18nRoot,
  } = useSpacesLimitAddonState(() => void modal.hide());

  return (
    <ConfirmationModal
      title={t(`${i18nRoot}.title`)}
      isOpen={modal.visible}
      onClose={() => void modal.hide()}
      onConfirm={() => void handleConfirm()}
      confirmText={t(`${i18nRoot}.confirm`)}
      disabled={isLoading || !addon || isSubmitting}
    >
      {isLoading ? (
        <Loader center />
      ) : (
        <SanitizeHTMLString content={buildDescription()} />
      )}
    </ConfirmationModal>
  );
};
